import{isObject as o}from"@primeuix/utils/object";var i=(r,t)=>o(r)&&r.hasOwnProperty(t)?r:t?{[t]:r}:r;export{i as toValues};
//# sourceMappingURL=index.mjs.map